import { React, useRef, useEffect, useState } from 'react';
import ClearIcon from '@mui/icons-material/Clear';
import TokenService from '../../services/TokenService'
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import CustomerOrRecyclerConfirmation from './CustomerOrRecyclerConfirmation'
import DriverForm from './DriverForm';
import { Link } from 'react-router-dom';

const DriverSignupWizard = (props) => {

    const [numberOfSteps, setNumberOfSteps] = useState(3);
    const [stepNumber, setStepNumber] = useState(1);

    function cancelClicked() {
        console.log("cancelClicked");
        props.Cancel();
    }


    let panel = null;
    if (stepNumber === 1) {
        panel = <CustomerOrRecyclerConfirmation Next={() => setStepNumber(2) } />
    }
    else if (stepNumber === 2) {
        panel = <DriverForm Next={() => setStepNumber(3)} />
    }
    else if (stepNumber === 3) {
            panel =
                <div>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <MailOutlineIcon sx={{ color: 'var(--sipzee-green)', fontSize: 50 }} />
                    </div>
                    <div style={{ fontSize: '17px', padding: '20px', fontWeight: 'bold', maxWidth: '600px', margin: '0 auto', textAlign: 'left' }} >Thank you for signing up - you have been emailed a link to complete the verification process.
                        If you do not receive this email or encounter issues, please send us a message at <a target="_blank" href="/ContactUs" >Sipzee Support </a>
                        and a team member will contact you shortly.  Please make sure to check your spam folder as well.
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Button
                                component={Link}
                                to='/Login'
                                style={{ alignSelf: 'center', maxWidth: '225px' }}
                                sx={{ my: 2, display: 'flex', background: 'var(--sipzee-green)' }}
                            >Login</Button>
                        </div>
                    </div>
                </div>
    }

  return (
      <div style={{ padding: '10px' }}>
          {stepNumber < 3 ?
              <Box display="flex"
                  justifyContent="flex-end"
                  alignItems="center"
                  noValidate
                  marginTop="5px"
              >
                  <Button onClick={() => cancelClicked()}>Cancel<ClearIcon /></Button>
              </Box>
            : ""}

           
          <div style={{ display: 'flex', justifyContent: 'center' }}>
              <LinearProgress variant="determinate" value={(stepNumber / numberOfSteps * 100)} sx={{ maxWidth: 400, flexGrow: 1 }} />
          </div>

          {panel }

      </div>
  )
  
}

export default DriverSignupWizard;